import { Select, On } from './helper';

const ScrollTo = {
  /**
   * Scrolls to an element with header offset
   */
  init() {
    this._initialListener();
  },


  _initialListener() {
    On(
      'click',
      '.top-button',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        const eventTarget = event.target;
        if (!['A', 'I'].includes(eventTarget.tagName)) return;

        const anchorElement = this._getAnchorAttrib(eventTarget);
        if (anchorElement === null) return;
        // this._scrollIntoView(anchorElement);
        this._elementTarget(anchorElement);
      }
    );

    On(
      'click',
      '#bootscore-navbar .nav-link',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        const eventTarget = event.target;
        if (eventTarget.tagName !== 'A') return;
        if (!this._isHomePage()) this._windowLocationHref(eventTarget);
        
        const anchorElement = this._getAnchorAttrib(eventTarget);
        if (!anchorElement) return;
        this._elementTarget(anchorElement);
      },
      true,
    );
  },


  _isHomePage() {
    const selectBase = Select('base');
    const baseAttribute = selectBase.getAttribute('class-attr');

    if (baseAttribute !== 'Home Page') return false;
    return true;
  },


  _getAnchorAttrib(target) {
    return (target.tagName === 'A')
      ? target.hash //getAttribute('href')
      : (target.tagName === 'I')
        ? this._getParentElement(target)
        : null;
  },


  _windowLocationHref(target) {
    const hrefAttribute = target.getAttribute('href');

    if (hrefAttribute === '#hero') return;
    window.location.href = hrefAttribute;
    return;
  },


  _getParentElement(target) {
    const parentElement = target.parentElement;
    return parentElement.hash;
  },


  _scrollIntoView(element) {
    const targetElement = Select(element);
    targetElement.scrollIntoView({ behavior: 'smooth' });
  },


  _elementTarget(element) {
    const targetElement = Select(element);

    if (!targetElement) return;
    this._scrollToTargetElement(this._getClientRect(Select(element)));
  },


  _scrollToTargetElement(targetRectElement) {
    const headerRect = this._getClientRect(Select('#masthead'));
    const scrollByYMiddle = this._scrollingDistance(targetRectElement.top, headerRect.height);

    window.scrollTo({
      top:  scrollByYMiddle,
      behavior: 'smooth'
    });
  },


  _getClientRect(element) {
    return element.getBoundingClientRect();
  },


  _scrollingDistance(top, offset) {
    // const padding = 80.96;
    const padding = 0;
    const winScrollY = window.scrollY || (window.pageYOffSet || 0);
    return top + winScrollY - padding - offset;
  },


  _isInViewport(top) {
    const viewportHeight = this._viewportHeight();
    const position = top / viewportHeight;

    if (position >= 0 && position <= 1) return true;
    return false;
  },


  _viewportHeight() {
    return window.innerHeight;
  }
};

export default ScrollTo;